import { IEmployeeLeaveResourceProps, IEmployeeLeaveResourceShortProps } from '../../props/employees/leaves/leave';
import { IPaginationResourceShort } from '../../props/general';
import Request from '../request';

const EmployeeLeaveService = {
  retrieve: async (qs?: string): Promise<{ data: IEmployeeLeaveResourceShortProps[], pagination: IPaginationResourceShort }> => {
    try {
      const results = await Request.get(`/api/employees/leaves?${qs || ''}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  read: async (id: string): Promise<IEmployeeLeaveResourceProps> => {
    try {
      const results = await Request.get(`/api/employees/leaves/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (data: FormData): Promise<IEmployeeLeaveResourceProps> => {
    try {
      const result = await Request.post(`/api/employees/leaves`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  update: async (id: string, data: FormData): Promise<IEmployeeLeaveResourceProps> => {
    try {
      const result = await Request.post(`/api/employees/leaves/${id}?_method=PUT`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  confirm: async (id: string, data: FormData): Promise<IEmployeeLeaveResourceProps> => {
    try {
      const result = await Request.post(`/api/employees/leaves/${id}/confirm`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  approve: async (id: string, data: FormData): Promise<IEmployeeLeaveResourceProps> => {
    try {
      const result = await Request.post(`/api/employees/leaves/${id}/approve`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  },
  reject: async (id: string, data: FormData): Promise<IEmployeeLeaveResourceProps> => {
    try {
      const result = await Request.post(`/api/employees/leaves/${id}/reject`, data, 'multipart/form-data');
      return result;
    } catch (e) {
      throw e;
    }
  }
};

export default EmployeeLeaveService;
